module.exports = __webpack_public_path__ + "img/img_1.30f7b5f1.png";